import { PLATFORM_CAPTIONS } from '@/constants';

export const STATUS_CONFIG = {
  success: {
    label: 'Success',
    className: 'text-success',
    icon: 'fa-check-circle',
    title: {
      playlist: 'All tracks transferred',
      conversion: 'All playlists transferred',
    },
  },
  failure: {
    label: 'Failed',
    className: 'text-danger',
    icon: 'fa-times-circle',
    title: {
      playlist: 'Transfer failed',
      conversion: 'Transfer failed',
    },
  },
  incomplete: {
    label: 'Incomplete',
    className: 'text-warning',
    icon: 'fa-exclamation-circle',
    title: {
      playlist: 'Some tracks failed to transfer',
      conversion: 'Some playlists failed to transfer',
    },
  },
  processing: {
    label: 'Processing',
    className: 'text-accent',
    icon: 'fa-spinner fa-spin',
    title: {
      playlist: 'Transfer in progress',
      conversion: 'Transfer in progress',
    },
  },
  skipped: {
    label: 'Skipped',
    className: 'text-muted',
    icon: 'fa-forward',
    title: {
      playlist: 'Already converted, skipped',
      conversion: 'All playlists already converted',
    },
  },
  pending: {
    label: 'Pending',
    className: 'text-muted',
    icon: 'fa-clock',
    title: {
      playlist: 'Waiting to start',
      conversion: 'Waiting to start',
    },
  },
};

export const PLATFORM_OPTIONS = [
  { value: '', label: 'Any platform' },
  { value: 'spotify', label: PLATFORM_CAPTIONS.spotify },
  { value: 'youtube', label: PLATFORM_CAPTIONS.youtube },
  { value: 'apple', label: PLATFORM_CAPTIONS.apple },
];

export const STATUS_OPTIONS = [
  { value: '', label: 'Any status' },
  ...Object.entries(STATUS_CONFIG).map(([value, { label }]) => ({
    value,
    label,
  })),
];

export const DATE_RANGE_OPTIONS = [
  { value: '7', label: 'Last 7 days' },
  { value: '30', label: 'Last 30 days' },
  { value: '90', label: 'Last 3 months' },
];

export const DEFAULT_FILTERS = {
  status: '',
  source: '',
  target: '',
  dateRange: '7',
};

export const getFromDate = (days) => {
  if (!days) return undefined;
  const date = new Date();
  date.setDate(date.getDate() - Number(days));
  return date.toISOString();
};
